import styled from 'astroturf/react'
const colorStrokeFocus = 'var(--colorStrokeFocus, var(--coreColorBlue600))'
const colorSurfaceAction = 'var(--colorSurfaceAction, var(--coreColorBlue600))'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue700))'
const colorTextInverseStandard = 'var(--colorTextInverseStandard, var(--coreColorNeutral0))'
const fontWeightBold = 'var(--fontWeightBold, 700)'
import { ButtonGroup } from '@calendly/ui/components/button-group'
import { useDropdown } from '@calendly/ui/components/dropdown'
import { PopupDropdownMenu } from '@calendly/ui/components/menu'

import { useI18n } from 'locales'

import { TimeButton } from '../../time_button'
import { TimeButtonWrapper, TimeButtonTimeDisplay, TimeButtonStyledMarker } from '../../styles'
import { sortInvitees } from '../../utils'

import { InviteeCountButton } from './invitee_count_button'
import { InviteeList } from './invitee_list'
import _StyledButtonGroup from "mobile_invitee_count_time_button-StyledButtonGroup.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/mobile_invitee_count_time_button.js?styleId=StyledButtonGroup";
import _StyledTimeButton from "mobile_invitee_count_time_button-StyledTimeButton.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/mobile_invitee_count_time_button.js?styleId=StyledTimeButton";


const StyledButtonGroup = /*#__PURE__*/styled(ButtonGroup, null, {
  displayName: "StyledButtonGroup",
  styles: _StyledButtonGroup
})

const StyledTimeButton = /*#__PURE__*/styled(TimeButton, null, {
  displayName: "StyledTimeButton",
  styles: _StyledTimeButton
})

export const MobileInviteeCountTimeButton = ({ isSelected, spot, ...props }) => {
  const { i18n } = useI18n()
  const [toggleDropdown, Dropdown] = useDropdown()
  const invitees = sortInvitees([...(spot.invitees || [])])
  const hasInvitees = invitees.length > 0
  const showInviteeCountButton = hasInvitees || isSelected

  if (isSelected) invitees.unshift({ full_name: i18n.t('publisher.title.you') })

  const openInviteeList = (e) => {
    if (invitees.length > 0) {
      toggleDropdown(e)
    }
  }

  return (
    <StyledButtonGroup isSelected={isSelected}>
      <StyledTimeButton
        isSelected={isSelected}
        spot={spot}
        {...props}
      />
      {showInviteeCountButton && <InviteeCountButton onClick={openInviteeList} isSelected={isSelected} invitees={invitees} />}
      <Dropdown>
        <PopupDropdownMenu>
          <InviteeList
            invitees={invitees}
            isSelected={isSelected}
            startTime={spot.start_time}
            toggleDropdown={toggleDropdown}
            {...props}
          />
        </PopupDropdownMenu>
      </Dropdown>
    </StyledButtonGroup>
  )
}
